import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { colors, calculateSpacing } from '@vds/theme';
import { IconData } from '@vds/icons';
import { DatePicker as CoreDatePicker } from '@vds-core/inputs';
import Calendar from './Calendar';
import { calculateRem } from '@uie/javascript-style-helpers';
import { BodyConfig, Micro, TypographyConfig } from '@vds/typography';

var DatePicker = function DatePicker(props) {
  var disabled = props.disabled;

  function _calculateInputPadding(error, readOnly, locked, type, readOnlyBorders) {
    if (type === 'calendar') {
      if ((readOnly || locked) && !readOnlyBorders) {
        return calculateRem(12, 16, 12, 32);
      } else {
        return calculateRem(12, 16, 12, 50);
      }
    } else {
      if ((readOnly || locked) && !readOnlyBorders) {
        return 0;
      } else {
        return calculateRem(12, 16);
      }
    }
  }

  return /*#__PURE__*/React.createElement(CoreDatePicker, _extends({}, props, {
    Calendar: Calendar,
    disabled: disabled,
    iconFocusState: false,
    focusState: false,
    iconConfig: IconData,
    calculateInputPadding: _calculateInputPadding,
    color: colors,
    placeholder: null,
    iconPosition: "left",
    maxWidth: undefined,
    minWidth: undefined,
    hoverState: false,
    overflowEllipsis: false,
    readOnlyBorders: false,
    required: true,
    renderErrorIcon: false,
    bodyConfig: BodyConfig,
    inputHeight: calculateRem(42),
    typescale: TypographyConfig.getTypescale(),
    labelMarginBottom: calculateRem(1),
    helperText: undefined,
    helperTextPlacement: undefined,
    Tooltip: undefined,
    tooltipTitle: undefined,
    tooltipContent: undefined,
    Micro: Micro
  }));
};

export default DatePicker;